import { SavingGoalsContainer } from '../../features/SavingGoals/SavingGoalsContainer'
import { Container } from '../../components/Container/Container'
import { SAVING_GOALS_BREADCRUMBS } from './constants'
import SavingGoalsContextProvider from '../../features/SavingGoals/Providers/SavingGolasContextProvider'
import SavingGoalsPopupProvider from '../../features/SavingGoals/Providers/SavingGoalsPopupProvider'
import SavingGoalsHistoryContextProvider from '../../features/SavingGoals/Providers/SavingGoalsHistoryContextProvider'
import SavingGoalsAbilityProvider from 'features/SavingGoals/Providers/SavingGoalsAbilityProvider'

export const SavingGoalsPage = () => {
  return (
    <SavingGoalsAbilityProvider>
      <SavingGoalsPopupProvider>
        <SavingGoalsContextProvider>
          <SavingGoalsHistoryContextProvider>
            <Container
              title="Saving goals"
              breadcrumbs={SAVING_GOALS_BREADCRUMBS}
            >
              <SavingGoalsContainer />
            </Container>
          </SavingGoalsHistoryContextProvider>
        </SavingGoalsContextProvider>
      </SavingGoalsPopupProvider>
    </SavingGoalsAbilityProvider>
  )
}
